module.exports = __webpack_public_path__ + "static/media/SA.2dd9486f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SA.svg
// module id = 2252
// module chunks = 7